<template>
  <div> 
    <v-card>
      <v-card-text class="mt-2" v-if="newInputFieldsAreVisible">
        <div>
          <h5 class="mb-8">Lägg till ny adress</h5>

          <v-text-field
            v-model="newInput.address"
            type="text"
            outlined
            label="Adress (ange även ev. lägenhetsnummer)"
          ></v-text-field>

          <v-text-field
            v-model="newInput.zip"
            type="text"
            outlined
            label="Postnummer"
          ></v-text-field>

          <v-text-field
            v-model="newInput.city"
            type="text"
            outlined
            label="Ort"
          ></v-text-field>
        </div>

        <v-card-actions class="justify-end mt-2" :style="{ marginBottom: '-1rem', padding: 'unset !important' }">
          <v-btn color="primary" :style="{ marginLeft: 'auto' }" @click="newInputFieldsAreVisible = false">
            <v-icon class="mr-2" size="small">$sl-cancel</v-icon>
            Avbryt
          </v-btn>
          <v-btn color="secondary" class="ml-2" @click="addNewAddress()">
            <v-icon class="mr-2" size="small">$sl-add</v-icon>
            Lägg till
          </v-btn>
        </v-card-actions>
      </v-card-text>

      <v-form ref="form" :lazy-validation="true" v-else>
        <template v-if="modeType === 'create'">
          <v-card-title>{{isTradeCert ? 'Beställ yrkesbeviskort' : 'BESTÄLL MASKINKORT'}}</v-card-title>

          <v-card-text>
            <MessageBox type="warning" class="pb-4" v-if="isCardInProcess">
              <h5>DET FINNS REDAN EN PÅGÅENDE BESTÄLLNING</h5>
              <p>
                Du kan inte beställa detta kort just nu eftersom det redan finns en pågående beställning för denna
                person och typ av kort. Du måste radera eller annullera liggande beställning innan du kan skapa en ny.
              </p>
            </MessageBox>
            <template v-if="personObj && Object.keys(personObj).length > 0">
              <p v-if="isTradeCert" class="mt-2 fontsize-14">
                Yrkesbeviskort till {{ personObj.text }}:
                ({{ personObj.companyId ? personObj.personalNumber : formatedPersonalNumber }}).
                <span v-if="priceId === 2">Denna beställning kommer innebära en tryckkkostnad.</span>
              </p>
              <p v-else class="mt-2 fontsize-14">
                Maskinkort till {{ personObj.text }} 
                {{ personObj.companyId ? `(${ personObj.personalNumber || formatedPersonalNumber })` : '' }}
                för maskinslaget {{ this.machines }}.
                <span v-if="priceId === 2">Denna beställning kommer innebära en tryckkkostnad.</span>
              </p>
            </template>
            <template v-else>
              <p class="mt-2 fontsize-14" v-if="isTradeCert">
                Yrkesbeviskort till {{ selectedPerson | fullName }} 
                ({{
                  selectedPerson.personalNumber | formatPnr
                }}) för {{getProfessions()}}.
                <span v-if="priceId === 2">Denna beställning kommer innebära en tryckkkostnad.</span>
              </p>
              <p class="mt-2 fontsize-14" v-else-if="personObj && Object.keys(personObj).length > 0">
                Maskinkort till {{ personObj.text }} 
                {{ personObj.companyId ? `(${ personObj.personalNumber || formatedPersonalNumber })` : '' }} 
                för maskinslaget {{ personObj.machines }}.
                <span v-if="priceId === 2">Denna beställning kommer innebära en tryckkkostnad.</span>
              </p>
            </template>
          </v-card-text>
        </template>
        <template v-if="modeType === 'edit'">
          <v-card-title>Kortbeställning</v-card-title>
        </template>

        <v-card-actions>
          <v-icon class="close" @click="close">$sl-close</v-icon>
        </v-card-actions>

        <!-- Show machine qualification starts here -->
        <v-card-text class="mt-n6" v-if="printOrder && Object.keys(printOrder).length > 0 && modeType === 'edit'">
          <v-row no-gutters>
            <v-col cols="4">
              <p class="overline">SKAPAD AV</p>
              <p class="mt-n3">
                <router-link :to="'/people/' + printOrder.createdBy.id">
                  {{ printOrder.createdBy | fullName }}
                </router-link>
                <template v-if="printOrder.createdByType === 'User'"
                  ><div>({{ printOrder.region.name }})</div></template
                >
              </p>
            </v-col>
            <v-col cols="4">
              <p class="overline">MOBILNUMMER</p>
              <p class="mt-n3" v-if="printOrder.createdBy && printOrder.createdBy.mobilephone">
                <a :href="`tel:${printOrder.createdBy.mobilephone}`">
                  {{ printOrder.createdBy.mobilephone | phoneNo }}</a
                >
              </p>
            </v-col>
            <v-col cols="4"
              ><p class="overline">E-POSTADRESS</p>
              <p class="mt-n3" v-if="printOrder.createdBy && printOrder.createdBy.email">
                <a :href="`mailto:${printOrder.createdBy.email}`"> {{ printOrder.createdBy.email }}</a>
              </p>
            </v-col>
            <v-col cols="4">
              <p class="overline">KORTINNEHAVARE</p>

              <p class="mt-n3">
                <router-link :to="'/people/' + get(printOrder, 'print.person', {}).id">
                  {{ get(printOrder, 'print.person', {}) | fullName }}
                </router-link>
              </p>
            </v-col>
            <v-col cols="4">
              <p class="overline">MOBILNUMMER</p>
              <p class="mt-n3" v-if="get(printOrder, 'print.person', {}).mobilephone">
                <a :href="`tel:${get(printOrder, 'print.person', {}).mobilephone}`">
                  {{ get(printOrder, 'print.person', {}).mobilephone | phoneNo }}</a
                >
              </p>
            </v-col>
            <v-col cols="4"
              ><p class="overline">E-POSTADRESS</p>
              <p class="mt-n3" v-if="get(printOrder, 'print.person', {}).email">
                <a :href="`mailto:${get(printOrder, 'print.person', {}).email}`">
                  {{ get(printOrder, 'print.person', {}).email }}</a
                >
              </p>
            </v-col>

            <v-col cols="12"
              ><p class="overline">Beställningsdatum</p>
              <div class="d-flex">
                <p class="mt-n3" v-if="printOrder.createdAt">
                  {{ printOrder.createdAt | date }}
                </p>
              </div>
            </v-col>

            <v-col cols="6"
              ><p class="overline">TYP AV KORT</p>
              <div class="d-flex">
                <!-- THIS WILL BE CHANGE LATER -->
                <p class="mt-n3">
                  {{ printOrder.printType === 'MachineCertificate' ? 'Maskinkort' : '' }}
                </p>
              </div>
            </v-col>

            <v-col cols="6"
              ><p class="overline">SPECIFICERING</p>
              <div class="d-flex">
                <p class="mt-n3">
                  {{ selMachines }}
                </p>
              </div>
            </v-col>

            <v-col cols="6">
              <p class="overline">Pris</p>
              <div class="d-flex">
                <p class="mt-n3">
                  {{ printOrder.price === 0 ? printOrder.price + ' kr' : '450 kr inkl. moms' }}
                </p>
              </div>
            </v-col>

            <v-col cols="6" v-if="printOrder.price === 0 && priceId != 2"
              ><p class="overline">KOMMENTAR</p>

              <div class="d-flex">
                <p class="mt-n3">{{ printOrder.reason }}</p>
              </div>
            </v-col>
            <v-col cols="12" v-if="printOrder.printOrderState"
              ><p class="overline">STATUS</p>
              <div class="d-flex">
                <p class="mt-n3">{{ printOrder.printOrderState.name }}</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-n6">
          <template v-if="modeType === 'create' && !isCardInProcess">
            <v-form ref="form" :lazy-validation="true" :disabled="isCardInProcess">
              <v-select
                outlined
                v-model="priceId"
                :items="prices"
                item-text="text"
                item-value="id"
                label="Pris (inkl. moms)"
              ></v-select>
              <v-text-field
                v-if="priceId === 1"
                label="Kommentar om eventuella rabatter"
                v-model="description"
                outlined
              />
              <v-select
                outlined
                v-model="personObj"
                :items="deliveryWorkplaces"
                item-text="fullAdressAndPerson"
                item-value="workplaceId"
                return-object
                label="Kortet skall skickas till"
              ></v-select>
              <v-select
                v-if="priceId === 2"
                outlined
                v-model="invoiceWorkplace"
                :items="invoiceWorkplaces"
                item-text="fullAdressAndPerson"
                item-value="workplaceId"
                return-object
                label="Fakturan skall skickas till"
              ></v-select>

              <v-btn color="secondary" @click="newInputFieldsAreVisible = true"  v-if="!newInputFieldsAreVisible && !isTradeCert">
                <v-icon class="mr-2" size="small">$sl-add</v-icon>
                Lägg till ny adress
              </v-btn>
            </v-form>
          </template>
          <v-checkbox v-if="selectedEmail!='' && priceId === 2"
            class="mt-6 fontsize-14"
            :class="!isTradeCert ? 'mt-6' : 'mt-n1'"
            hide-details
            :label="'Skicka fakturan med e-post (fakturan skickas till ' + selectedEmail + ')'"            
            v-model="chkSendByEmail"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="justify-end mt-2">
          <v-btn @click="close"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
          <v-btn color="secondary" v-if="modeType === 'create'" :disabled="isCardInProcess || !canCreate" @click="createCard" >
            <v-icon>$sl-send</v-icon>BESTÄLL
          </v-btn>
          <v-btn color="secondary" v-if="modeType === 'edit' && canDeletePrintOrder" @click="deleteCard" :disabled="!canDelete">
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-dialog v-model="thankYou" :max-width="'670px'">
      <v-card v-if="personObj && Object.keys(personObj).length > 0">
        <v-card-title>{{isTradeCert ? 'Yrkesbeviskort' : 'Maskinkort' }} BESTÄLLT</v-card-title>
        <v-card-text>
          <p> 
            Ett {{isTradeCert ? 'yrkesbeviskort' : 'maskinkort' }} har beställts till {{ personObj.text }} 
            {{ personObj.companyId ? `(${ personObj.personalNumber || formatedPersonalNumber })` : '' }}
            för {{isTradeCert ? 'yrken ' + getProfessions() : 'maskinslag ' + personObj.machines}}.
          </p>
        </v-card-text>

        <v-card-actions class="justify-end mt-n6">
          <v-icon
            class="close"
            @click="
              thankYou = false
              close()
            "
            >$sl-close</v-icon
          >
        </v-card-actions>
        <v-card-actions class="justify-end mt-n6">
          <v-btn
            color="primary"
            @click="
              thankYou = false
              close()
            "
          >
            <v-icon>$sl-cancel</v-icon>
            <div class="mr-5">OK</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import API from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import DatePicker from '@/components/common/DatePicker'
import MessageBox from '@/components/common/MessageBox'
import get from 'lodash/get'
import uniq from 'lodash/uniq'
import filter from 'lodash/filter'
import find from 'lodash/find'
import {Regions, RulesMixin, CanIDo} from '@/components/mixins'
// @group Person
// PersonMachineQualificationModal component
export default {
  name: 'CreateShowCard',
  mixins: [Regions, RulesMixin, CanIDo],
  components: {
    DatePicker,
    MessageBox
  },
  props: {
    mode: {
      type: String,
      default: ''
    },
    printCardId: {
      type: Number,
      default: 0
    },
    isTradeCert: {
      type: Boolean,
      default: false
    },
    education: {
      type: Object,
      default: function () {
        return {}
      }
    },
    printOrders: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: () => ({
    people: [],
    allCompanies: [],
    allWorkplaces: [],
    invoiceWorkplace: {},
    chkSendByEmail: false,
    thankYou: false,
    modeType: '',
    machines: '',
    description: '',
    personObj: null,
    priceId: null,
    printOrder: {},
    prices: [
      {id: 1, text: '0 kr'},
      {id: 2, text: '450 kr'}
    ],
    newInput: { address: null, zip: null, city: null },
    newInputFieldsAreVisible: false,
    newAddresses: []
  }),

  watch: {
    printCardId: {
      immediate: true,
      handler() {
        this.getCardById()
      }
    },
    mode: function (val) {
      this.modeType = val
    }
  },

  async created() {
    this.modeType = this.mode
    this.getEducationsSelectMachines()
    await this.getCardById()
    await this.getCompanies()    
  },
  computed: {
    ...mapGetters('person', ['selectedPerson']),    
    // education() {
    //   return filter(this.selectedPerson.educations, function (o) {
    //     return o.basicEducationCertificate != null
    //   })[0]
    // },
    formatedPersonalNumber() {
      return this.$options.filters.formatPnr(this.personObj.personalNumber)
    },
    selectedEmail(){      
      if(this.invoiceWorkplace && this.invoiceWorkplace.email && this.invoiceWorkplace.email!='')
        return this.invoiceWorkplace.email 
      return ''
    }, 
    isCardInProcess() {
      if (!(this.printOrders && this.printOrders.length > 0)) return
      let val = false
      let processStatuses = ['created', 'approved', 'awaitingPayment']
      this.printOrders.forEach(c => {
        const {state} = c.printOrderState
        val = processStatuses.includes(state)
      })
      return val
    },
    canDeletePrintOrder() {
      const status = get(this.printOrder, 'printOrderState.state', '')
      if (!status) return
      return Boolean(status == 'created' || status == 'approved')
    },
    selMachines() {
      let machines = ''
      let machineCertificateMachines = get(this.printOrder, 'print.machineCertificateMachines', [])
      machineCertificateMachines.forEach(m => {
        if (machines != '') machines += ', '
        machines += m.machine.name
      })
      return machines.replace(/\s*,\s*/g, ', ')
    },

    invoiceWorkplaces() {
      
      const invoiceWorkplaces = []
      this.allCompanies.forEach(c => { 
        c.workplaces.forEach(w => {
          if (w.isInvoiceWorkplace) {
            invoiceWorkplaces.push({
              text: c.name,
              workplaceId: w.id,
              email: w.invoiceAddressEmail,
              workplace: w,
              companyId: c.id,
              id: c.id,
              personalNumber: c.organizationalNumber,
              fullAdressAndPerson: `${c.name}: ${w.name} (${w.postalAddress1}, ${w.postalZip} ${w.postalCity})`,
              educationId: (this.education && this.education.id) ? this.education.id :  -1,
              machines: this.machines
            })
          }
        })
      })

      if (invoiceWorkplaces && invoiceWorkplaces.length == 1) {
        this.invoiceWorkplace = invoiceWorkplaces[0]
      }

      return [...invoiceWorkplaces, this.personAddress]
    },

    deliveryWorkplaces() {
      const deliveryWorkplaces = []

      this.personObj = null
      this.allCompanies.forEach(c => {
        c.workplaces.forEach(w => {
          if (w.isDeliveryWorkplace) {
            deliveryWorkplaces.push({
              text: c.name,
              email: w.email,
              workplaceId: w.id,
              workplace: w,
              companyId: c.id,
              id: c.id,
              personalNumber: c.organizationalNumber,
              fullAdressAndPerson: `${c.name}: ${w.name} (${w.postalAddress1}, ${w.postalZip} ${w.postalCity})`,
              educationId: (this.education && this.education.id) ? this.education.id :  -1,
              machines: this.machines
            })
          }
        })
      })
      if (deliveryWorkplaces && deliveryWorkplaces.length == 1) {
        this.personObj = deliveryWorkplaces[0]
      }

      return [...deliveryWorkplaces, ...this.newAddresses, this.personAddress ]
    },

    personAddress() {
      if ( !get(this, 'selectedPerson.address1', null) ) return []
      return {
        text: this.selectedPerson.firstName + ' ' + this.selectedPerson.lastName,
        id: this.selectedPerson.id,
        email: this.selectedPerson.email,
        personalNumber: this.selectedPerson.personalNumber,
        fullAdressAndPerson: `${this.selectedPerson.firstName} ${this.selectedPerson.lastName}  (${this.selectedPerson.address1}, ${this.selectedPerson.zip} ${this.selectedPerson.city})`,
        educationId: (this.education && this.education.id) ? this.education.id :  -1,
        machines: this.machines
      }
    }
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('order', 'delete');
    },
    canCreate(){
      return this.canIDo('order', 'create');
    },
  },

  methods: {
    get: get,
    async getEducationsSelectMachines() {
      let machineArr = []

      await API.getEducationsSelectMachines( {advSearch: {personId: this.selectedPerson.id}})
        .then(async res => {
          await res.data.forEach(element => {
            
            element.educations.forEach(edu => {
                let machineCertificateMachines = get(edu, 'educationProfessionOrientations', [])              

                machineCertificateMachines.forEach(m => {
                //if (this.machines != '') this.machines += ', '
                  //this.machines += m.professionMachineOrientation.machine.name
                  if(m.professionMachineOrientation && m.professionMachineOrientation.machine && m.professionMachineOrientation.machine.name)
                    machineArr.push(m.professionMachineOrientation.machine.name)
              })
            });

            this.machines = uniq(machineArr).join(", ")
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    async getCompanies() {
      this.allCompanies = []      

      if(this.isTradeCert) {
        let companyIds = []
        this.selectedPerson.employments.map(e => {
              return companyIds.push({companyId: e.companyId})
            })
          uniq(companyIds).forEach(async i => {
            let cmp = await this.getCompany(i.companyId)
            if (i.companyId == cmp.id && !find(this.allCompanies, {id: i.companyId})) {
              this.allCompanies.push(cmp)
            }
          })
      }      
      else {      
        await API.getPersonQualificationTime(this.selectedPerson.id)
        .then(res => {
          let companyIds = []

          res.data.educations.forEach(e => {
            e.apprenticeships.map(a => {
              return companyIds.push({companyId: a.companyId})
            })
          })

          uniq(companyIds).forEach(async i => {
            let cmp = await this.getCompany(i.companyId)
            if (i.companyId == cmp.id && !find(this.allCompanies, {id: i.companyId})) {
              this.allCompanies.push(cmp)
            }
          })
        })
        .catch(error => {
          console.log('get document error, ', error)
        })
      }
    },
    /**
     * @vuese
     * Used fetch the company by id
     * @arg The argument is an integer value representing company id
     */
    async getCompany(id) {
      return await API.getCompany(id)
        .then(response => {
          return response.data
        })
        .catch(error => {
          console.log('get getCompany', error.response)
        })
    },

    async orderTradeCertDuplicate() { 
      if(!(this.selectedPerson && this.selectedPerson.id))
        return
      const dWorkplace = this.personObj.workplace
      const iWorkplace = this.invoiceWorkplace.workplace

      const hasDeWorkplace = Boolean(dWorkplace && Object.keys(dWorkplace).length > 0)
      const hasInWorkplace = Boolean(iWorkplace && Object.keys(iWorkplace).length > 0)

      let delivery = {
        deliveryAttention: hasDeWorkplace
          ? dWorkplace.deliveryAddressAttention
          : `${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
        deliveryPostalAddress: hasDeWorkplace ? dWorkplace.postalAddress1 : this.selectedPerson.address1,
        deliveryPostalAddress2: hasDeWorkplace ? dWorkplace.postalAddress2 : this.selectedPerson.address2,
        deliveryZipCode: hasDeWorkplace ? dWorkplace.postalZip : this.selectedPerson.zip,
        deliveryCity: hasDeWorkplace ? dWorkplace.postalCity : this.selectedPerson.city,
        deliveryCountry: hasDeWorkplace ? dWorkplace.postalCountry : this.selectedPerson.country ? this.selectedPerson.country : 'SE',
        reason: this.description,
        price: this.priceId === 1 ? 0 : this.priceId === 2 ? 450 : null
      }
      let invoice = {
        invoiceAttention: hasInWorkplace
          ? iWorkplace.invoiceAddressAttention
          : `${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
        invoicePostalAddress: hasInWorkplace ? iWorkplace.postalAddress1 : this.selectedPerson.address1,
        invoicePostalAddress2: hasInWorkplace ? iWorkplace.postalAddress2 : this.selectedPerson.address2,
        invoiceZipCode: hasInWorkplace ? iWorkplace.postalZip : this.selectedPerson.zip,
        invoiceCity: hasInWorkplace ? iWorkplace.postalCity : this.selectedPerson.city,
        invoiceCountry: hasInWorkplace ? iWorkplace.postalCountry : this.selectedPerson.country,
        invoiceEmail: (this.priceId==2 && this.chkSendByEmail) ? this.selectedEmail : ''
      }

      await API.orderTradeCertDuplicate(this.selectedPerson.id, {data: {...delivery, ...invoice}})
        .then(res => { 
           this.thankYou = true
           this.$refs.form.reset()
        })
        .catch(error => {
          console.log('Store - failed to get user: ' + error)
        })
    },

    async createCard() { 
      if(this.isTradeCert==true) {
        this.orderTradeCertDuplicate()
      }
      else {
        if(!(this.education && this.education.id))
          return
        const dWorkplace = get(this, 'personObj.workplace', {})
        const iWorkplace = get(this,'invoiceWorkplace.workplace', {})

        const hasDeWorkplace = Boolean(dWorkplace && Object.keys(dWorkplace).length > 0)
        const hasInWorkplace = Boolean(iWorkplace && Object.keys(iWorkplace).length > 0)

        let delivery = {
          deliveryAttention: this.newAddresses.length ? '' : (hasDeWorkplace && dWorkplace.deliveryAddressAttention) ? dWorkplace.deliveryAddressAttention
            : `${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
          deliveryPostalAddress: this.newAddresses.length ? this.personObj?.text : (hasDeWorkplace && dWorkplace.postalAddress1) ? dWorkplace.postalAddress1 : this.selectedPerson.address1,
          deliveryPostalAddress2: (hasDeWorkplace && dWorkplace.postalAddress2) ? dWorkplace.postalAddress2 : this.selectedPerson.address2,
          deliveryZipCode: this.newAddresses.length ? this.personObj?.zip : (hasDeWorkplace && dWorkplace.postalZip) ? dWorkplace.postalZip : this.selectedPerson.zip,
          deliveryCity: this.newAddresses.length ? this.personObj?.city : (hasDeWorkplace && dWorkplace.postalCity) ? dWorkplace.postalCity : this.selectedPerson.city,
          deliveryCountry: (hasDeWorkplace && dWorkplace.postalCountry) ? dWorkplace.postalCountry : this.selectedPerson.country,
          reason: this.description,
          price: this.priceId === 1 ? 0 : this.priceId === 2 ? 450 : null
        }
        let invoice = {
          invoiceAttention: hasInWorkplace
            ? iWorkplace.invoiceAddressAttention
            : `${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
          invoicePostalAddress: hasInWorkplace ? iWorkplace.postalAddress1 : this.selectedPerson.address1,
          invoicePostalAddress2: hasInWorkplace ? iWorkplace.postalAddress2 : this.selectedPerson.address2,
          invoiceZipCode: hasInWorkplace ? iWorkplace.postalZip : this.selectedPerson.zip,
          invoiceCity: hasInWorkplace ? iWorkplace.postalCity : this.selectedPerson.city,
          invoiceCountry: hasInWorkplace ? iWorkplace.postalCountry : this.selectedPerson.country,
          invoiceEmail: (this.priceId==2 && this.chkSendByEmail) ? this.selectedEmail : ''
        }

        await API.createPrintOrders(this.education.id, {personId: this.selectedPerson.id, data: {...delivery, ...invoice}})
          .then(res => {
            this.thankYou = true
            this.$refs.form.reset()
          })
          .catch(error => {
            console.log('Store - failed to get user: ' + error)
          })
      }
    },

    async deleteCard() {
      const res = await this.$dialog.confirm({
        text: 'Radering går inte att ångra.',
        title: 'Är du säker på att du vill radera detta maskinkort?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })
      if (res !== true) return
      await API.deletePrintOrdersById(this.printCardId)
        .then(res => {
          if (res.data && res.data.deletedRows === 1) {
            this.$emit('deleted', this.printCardId)
          }
        })
        .catch(error => {
          console.log('Failed to get card: ' + error)
        })
    },

    async getCardById() {
      if (!this.printCardId) return
      await API.getPrintOrdersById(this.printCardId)
        .then(res => {
          this.printOrder = res.data
        })
        .catch(error => {
          console.log('Failed to get card: ' + error)
        })
    },
    getProfessions(){
      let ret = ''
      ret = this.selectedPerson.tradeCertificates.filter(f => (f.approvedById && f.approvedById>0)).map(m => m.profession.name).join(', ').toLowerCase()
      
      return ret
    },
    close() {
      this.description = ''
      this.priceId = null
      this.$emit('close')
    },

    addNewAddress() {
      if ( Object.values(this.newInput).some(input => !input) ) return
      this.newAddresses = [
        ...this.newAddresses, {
          text: this.newInput.address,
          fullAdressAndPerson: `${ this.newInput.address }, (${ this.newInput.zip } ${ this.newInput.city })`,
          zip: this.newInput.zip,
          city: this.newInput.city,
          machines: this.machines
        }
      ]
      this.clearNewAddressField()
      this.$events.fire('showInfo', 'Adressen har lagts till.')
    },

    clearNewAddressField() {
      this.newInputFieldsAreVisible = false
      this.newInput = Object.assign(this.newInput, { address: null, zip: null, city: null })
    }
  }
}
</script>

<style>
</style>
